/* tslint:disable */
/* eslint-disable */
/**
 * PRTIMES Media User API
 * メディアユーザーマイページ用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BusinessCategorySummary,
    BusinessCategorySummaryFromJSON,
    BusinessCategorySummaryFromJSONTyped,
    BusinessCategorySummaryToJSON,
} from './BusinessCategorySummary';

/**
 * 
 * @export
 * @interface GetBusinessCategorySummaryResponse
 */
export interface GetBusinessCategorySummaryResponse {
    /**
     * 
     * @type {number}
     * @memberof GetBusinessCategorySummaryResponse
     */
    status: number;
    /**
     * 
     * @type {string}
     * @memberof GetBusinessCategorySummaryResponse
     */
    message: string;
    /**
     * 
     * @type {BusinessCategorySummary}
     * @memberof GetBusinessCategorySummaryResponse
     */
    data: BusinessCategorySummary;
}

export function GetBusinessCategorySummaryResponseFromJSON(json: any): GetBusinessCategorySummaryResponse {
    return GetBusinessCategorySummaryResponseFromJSONTyped(json, false);
}

export function GetBusinessCategorySummaryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetBusinessCategorySummaryResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': BusinessCategorySummaryFromJSON(json['data']),
    };
}

export function GetBusinessCategorySummaryResponseToJSON(value?: GetBusinessCategorySummaryResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': BusinessCategorySummaryToJSON(value.data),
    };
}

